import React from 'react';
export function Footer() {
  return <footer className="w-full py-12" style={{
    backgroundColor: '#0d1b2e'
  }} role="contentinfo" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-32">
        {/* Row 1: Logo + Tagline */}
        <div className="mb-6" data-id="element-33">
          <p className="font-heading text-xl font-bold text-white mb-2" data-id="element-34">
            ✝️ Mega Pack Catequesis Lista
          </p>
          <p className="text-gray-400 text-sm" data-id="element-35">
            Recursos educativos para docentes y catequistas apasionados.
          </p>
        </div>

        {/* Divider */}
        <div className="w-24 h-px mx-auto mb-6" style={{
        backgroundColor: '#c9a84c',
        opacity: 0.4
      }} aria-hidden="true" data-id="element-36" />

        {/* Row 2: Copyright */}
        <p className="text-gray-500 text-sm" data-id="element-37">
          © 2025 Todos los derechos reservados.
          <br className="sm:hidden" data-id="element-38" /> Hecho con ❤️ para la comunidad
          catequística argentina.
        </p>
      </div>
    </footer>;
}